import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

const FusionSectionText: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  return <p className={classNames(styles.fusionSectionText, className)}>{children}</p>;
};

export default FusionSectionText;
